module.exports = "<div id=\"container\" ></div>\n<!-- <highcharts-chart \n[Highcharts]=\"Highcharts\"\n[options]=\"chartOptions\"\nstyle=\"width: 100%; height: 400px; display: block;\"\n></highcharts-chart> -->"


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/users/stacked-bar-chart/stacked-bar-chart.component.html
// module id = ../../../../../src/app/users/stacked-bar-chart/stacked-bar-chart.component.html
// module chunks = main